import { dec } from './dec'
import type { Formula } from './formula'

/** Confine col JSON esterno: qui i campi sono ancora stringhe e numeri grezzi. */
type Grezzo = Record<string, unknown>

function campo(g: Grezzo, chiave: string): Grezzo {
  return g[chiave] as Grezzo
}

/**
 * Converte una formula deserializzata da JSON: i valori costanti diventano
 * Dec, il resto dell'albero e' gia' nella forma giusta perche' contiene solo
 * stringhe, numeri e nodi figli.
 */
export function formulaDaJson(raw: Grezzo): Formula {
  switch (raw.op) {
    case 'costante':
      return { op: 'costante', valore: dec(raw.valore as string) }
    case 'lettura':
      return {
        op: 'lettura',
        contatore: raw.contatore,
        tipologiaConsumo: raw.tipologiaConsumo,
      } as Formula
    case 'rigo':
      return { op: 'rigo', quadro: raw.quadro, rigo: raw.rigo } as Formula
    case 'somma':
      return { op: 'somma', termini: (raw.termini as Grezzo[]).map(formulaDaJson) }
    case 'differenza':
      return { op: 'differenza', a: formulaDaJson(campo(raw, 'a')), b: formulaDaJson(campo(raw, 'b')) }
    case 'prodotto':
      return {
        op: 'prodotto',
        fattore: formulaDaJson(campo(raw, 'fattore')),
        aliquota: raw.aliquota as string,
      }
    case 'seTipologia':
      return {
        op: 'seTipologia',
        tipologia: raw.tipologia,
        allora: formulaDaJson(campo(raw, 'allora')),
        altrimenti: formulaDaJson(campo(raw, 'altrimenti')),
      } as Formula
    default:
      throw new Error(`operazione di formula sconosciuta: ${String(raw.op)}`)
  }
}
